import React from 'react';
import { SquaresPlusIcon } from '@heroicons/react/20/solid';

import Sidebar from '@components/Sidebar';

const OnboardingChannels = ({ disabled }) => {
	return (
		<Sidebar.Item to="/channels" disabled={disabled}>
			<SquaresPlusIcon />
			Channels
		</Sidebar.Item>
	);
};

export default OnboardingChannels;
